<template>
  <div>
    <div id="wrapper" class="d-flex">
      <div id="page-content-wrapper">
        <nav
          class="pl-0 navbar navbar-expand-lg navbar-light bg-na-principal border-bottom fixed-top custom-navbar"
          :class="{ 'mobile-responsive': isMobile }"
        >
          <hamburger v-if="isMobile" class="pl-4" />
          <div
            v-if="!isMobile"
            class="sidebar-menu-button"
            :class="{ active: isNavOpened }"
          >
            <hamburger :color="'bg-white'" :show-title="true" />
          </div>
          <div class="sidebar-heading">
            <img alt="logo" height="63px" :src="logo" width="190px" />
          </div>
          <div
            id="navbarSupportedContent"
            class="collapse navbar-collapse show float-right left"
          >
            <ul
              class="navbar-nav mr-auto mt-2 mt-lg-0 d-flex align-items-center"
            >
              <li>
                <droppable v-if="false" class="action-item-help">
                  <div class="media align-items-center">
                    <span class="avatar avatar-sm rounded-circle deticket">
                      <em class="fal fa-user-headset color-white" />
                    </span>
                  </div>

                  <template #drop>
                    <div
                      class="deticket-box dropdown-list dropdown-menu dropdown-menu-custom custom-right show mt-4"
                    >
                      <div
                        class="cursor-pointer"
                        @click="onNavigateToCreateTicket"
                      >
                        <div class="dropdown-item nav-list-item">
                          <em
                            class="fas fa-file-plus font-20 color-green mr-2"
                          />
                          <div
                            class="color-black font-16 font-weight-normal ml-2 pl-1"
                          >
                            Crear Solicitud
                          </div>
                        </div>
                      </div>

                      <div
                        class="cursor-pointer"
                        @click="onNavigateToViewTickets"
                      >
                        <div class="dropdown-item nav-list-item">
                          <em
                            class="fas fa-file-search font-20 color-green mr-2"
                          />
                          <div
                            class="color-black font-16 font-weight-normal ml-1"
                          >
                            Ver Solicitudes
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- <div class="deticket-box dropdown-menu show">
                      <div
                        class="dropdown-item nav-list-item cursor-pointer d-flex"
                        @click="onNavigateToCreateTicket"
                      >
                        <em class="fas fa-file-plus font-20 color-green mr-2" />
                        <div
                          class="color-black font-16 font-weight-normal ml-1"
                        >
                          Crear Solicitud
                        </div>
                      </div>

                      <div
                        class="dropdown-item nav-list-item cursor-pointer d-flex"
                        @click="onNavigateToViewTickets"
                      >
                        <em
                          class="fas fa-file-search font-20 color-green mr-2"
                        />
                        <div
                          class="color-black font-16 font-weight-normal ml-1"
                        >
                          Ver Solicitudes
                        </div>
                      </div>
                    </div> -->
                  </template>
                </droppable>
                <droppable class="action-item-notification">
                  <div class="media align-items-center">
                    <span class="avatar avatar-sm rounded-circle">
                      <em class="fas fa-bell color-green" />
                    </span>
                  </div>
                </droppable>

                <droppable v-if="false" class="action-item-help">
                  <div class="media align-items-center">
                    <span class="avatar avatar-sm rounded-circle">
                      <em class="fal fa-question-circle color-green" />
                    </span>
                  </div>
                  <template #drop>
                    <card
                      class="position-relative nav-card top-60 w-card"
                      :row-elements="helpCard.rowElements"
                    >
                      <template #section-bottom>
                        <div class="row">
                          <div class="col-12 mb-2">
                            <span class="font-15">
                              Mesa de Apoyo
                            </span>
                          </div>
                          <div class="col-12">
                            <Link
                              color="gray-6"
                              color-icon="gray-7"
                              icon="fas fa-phone-alt"
                              :text="contactInfo.phone"
                              :with-border="false"
                            />
                          </div>
                          <div class="col-12">
                            <Link
                              color="gray-6"
                              color-icon="gray-7"
                              icon="fas fa-envelope"
                              :text="contactInfo.mail"
                              :with-border="false"
                            />
                          </div>
                        </div>
                      </template>
                    </card>
                  </template>
                </droppable>
              </li>
              <li>
                <custom-user-info
                  class="ml-3 custom-user-info"
                  :last-login-date="new Date(userInfo.lastlogindate)"
                  :row-actions="userCard.rowActions"
                  :row-elements="userCard.rowElements"
                />
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
    <modal-password
      :show="displayChangeUserPassword"
      @on-close="onClosing"
      @submit="changePassword"
    />

    <my-profile
      v-if="profileModalVisible"
      v-model="profileModalVisible"
      :save-profile="updateMyProfile"
      :user-info="{ ...userInfo, roleId: userInfo.roleid }"
    />
    <!-- <profile-info
      v-if="updateProfileVisible"
      :save-profile="updateMyProfile"
      :user="userInfo"
      value
      @close="updateProfileVisibleHandler"
    /> -->
  </div>
</template>

<script>
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters, mapState, mapMutations } from 'vuex';
import Card from './card';
import Hamburger from './hamburger';
import CustomUserInfo from 'CustomUserInfoPanel';
import ModalPassword from '@quisit/mipe-modal-password';
import Droppable from 'custom-droppable';
import { MyProfile, ProfileInfo } from 'mipe-security';
import { updateMyProfile as _updateMyProfile } from '@/modules/user/api.js';

import { changeUserPassword as _ChangeUserPassword } from '@/modules/user/api';
import alert from '@quisit/mipe-utils/mixins/alert.mixin';

const CASE_LIST_ROUTE_NAME = 'CaseListMain';
const CREATE_CASE_ROUTE_NAME = 'CreateTicket';
const KEY_PROFILE_UPDATED = 'profile-update-flag';

export default {
  components: {
    Droppable,
    Card,
    Hamburger,
    CustomUserInfo,
    MyProfile,
    ProfileInfo,
    ModalPassword,
  },
  mixins: [alert],
  props: {
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    excludeHelpCard: {
      type: Array,
      default: () => [], //array strings, para excluir items de caja de ayuda
    },
    contactInfo: {
      type: Object,
      default: () => ({
        phone: '787-773-6147',
        mail: 'apoyoconversion@de.pr.gov',
      }),
    },
    logo: {
      type: String,
      required: true,
    },
    logout: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isUserPasswordChangeVisible: false,
      isStudentForView: false,
      profileModalVisible: false,
      updateProfileVisible: false,
      studentInfo: {},
      enrollmentSchoolData: [],
      peiHistoryData: {},
      academicYears: [],
      therapies: [],
      studentStatuses: [],
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
      isNavOpened: 'getIsNavOpen',
    }),
    ...mapState(appModuleName, [
      'showStudentInfo',
      'selectedStudentId',
      'isOpenSearchStudent',
    ]),
    displayChangeUserPassword() {
      return this.isUserPasswordChangeVisible;
    },
    userCard() {
      return {
        rowElements: [
          {
            text: this.userInfo.role,
            icon: 'fas fa-key',
            colorIcon: 'orange',
            color: 'none',
            withBorder: false,
          },
          {
            text: this.userInfo.name,
            icon: 'fas fa-user',
            colorIcon: 'orange',
            color: 'none',
            withBorder: false,
          },
          {
            text: this.userInfo.email,
            icon: 'fas fa-envelope',
            colorIcon: 'orange',
            color: 'none',
            withBorder: false,
          },
        ],
        rowActions: [
          {
            text: 'Mi Perfil',
            icon: 'fas fa-address-card',
            colorIcon: 'green',
            color: 'green',
            withBorder: true,
            click: () => this.profileModalVisibilityHandler(true),
          },
          {
            text: 'Cambiar Contraseña',
            icon: 'fas fa-repeat-alt',
            colorIcon: 'green',
            color: 'green',
            withBorder: true,
            click: this.ShowHidePasswordChange,
          },
          {
            text: 'Salir',
            icon: 'fas fa-sign-out-alt',
            colorIcon: 'green',
            color: 'green',
            withBorder: true,
            click: () => this.logout(),
          },
        ],
      };
    },
    helpCard() {
      let rowElements = [
        { text: 'Manual', icon: 'fas fa-book' },
        { text: 'Videos', icon: 'fas fa-video' },
      ];
      return {
        rowElements: rowElements.filter(
          (item) => !this.excludeHelpCard.includes(item.text)
        ),
      };
    },
  },
  mounted() {
    this.updateProfileVisibleHandler();
  },
  methods: {
    ...mapMutations(appModuleName, [
      'setShowStudentInfo',
      'setSelectedStudentId',
    ]),
    ShowHidePasswordChange() {
      this.isUserPasswordChangeVisible = true;
    },
    onClosing() {
      this.isUserPasswordChangeVisible = false;
    },
    onOpenSearchStudentHandler() {
      this.$refs.studentSearchRef.showModal();
    },
    onNavigateToViewTickets() {
      this.$router.push({
        name: CASE_LIST_ROUTE_NAME,
      });
    },
    onNavigateToCreateTicket() {
      this.$router.push({
        name: CREATE_CASE_ROUTE_NAME,
      });
    },
    profileModalVisibilityHandler(state) {
      this.profileModalVisible = state;
    },
    updateMyProfile(params) {
      return _updateMyProfile(params);
    },
    updateProfileVisibleHandler(value) {
      if (value != null) {
        sessionStorage.setItem(KEY_PROFILE_UPDATED, value);
      }
      this.updateProfileVisible =
        sessionStorage.getItem(KEY_PROFILE_UPDATED) === 'true';
    },
    onCloseHandler() {
      this.setShowStudentInfo(false);
    },
    async changePassword(e) {
      let data = {
        currentPassword: e.currentPassword,
        confirmPassword: e.confirmPassword,
        newPassword: e.newPassword,
      };

      await _ChangeUserPassword(data)
        .then((response) => {
          if (!response.error) {
            this.onClosing();

            this.ShowToast(
              'Proceso Exitoso',
              'Su contraseña ha sido cambiada exitosamente.',
              'success'
            );
            this.$emit('on-closing');
          }
        })
        .catch((error) => {
          this.ShowToast('', error.response.data.message, 'error');
        });
    },
  },
};
</script>

<style scoped>
.div-help {
  margin-left: -10px;
  color: #ff7058;
}
.help-text {
  margin-left: -10px;
}
.help-information {
  margin-left: -10px !important;
}
.information-text {
  margin-left: -7px;
  font-family: 'Lato', sans-serif;
  font-size: 12px;
}
.support-table {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  opacity: 1;
}
.support-information {
  text-align: left;
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #20a874 !important;
  opacity: 1;
}
.support-label {
  margin-left: 11px !important;
  text-decoration: underline;
  font-family: 'Lato', sans-serif;
  font-size: 13px;
}
.shadow-top {
  -moz-box-shadow: inset 0 10px 10px -10px grey;
  -webkit-box-shadow: inset 0 10px 10px -10px grey;
  box-shadow: inset 0 10px 10px -10px grey;
}
.alert-indicator {
  position: absolute;
  top: 32px;
  right: 157px;
  background: #fd3737 0% 0% no-repeat padding-box;
  color: #fff;
  width: 15px;
  height: 15px;
  opacity: 1;
  line-height: 15px;
  text-align: center;
  font-size: 10px;
}

.dropdown-menu-custom {
  top: 95% !important;
}

.nav-item .media {
  margin-left: 20px;
}

.nav-item .media em {
  font-size: 1.225rem;
}

.user-panel {
  margin-right: 10rem;
}

.nav-list-item {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  padding: 15px 15px;
}

.custom-user-info ::v-deep > .user-panel > .dropdown-menu {
  top: 80px;
  margin-right: 0.3rem;
  min-width: 15rem;
}

.sidebar-menu-button {
  background-color: #3f5b60;
  width: 118px;
  height: 85px;
  padding-top: 16px;
}

.sidebar-menu-button.active {
  background-color: #b5c3bc;
}

@media screen and (max-width: 991px) and (min-width: 768px) {
  .custom-user-info ::v-deep > .user-panel > .dropdown-menu {
    top: 5rem;
    margin-right: 0.3rem;
    min-width: 15rem;
  }

  ul.navbar-nav {
    height: 55px;
    width: 42%;
  }

  ul.navbar-nav li:nth-child(2) {
    margin-top: -4.19rem;
  }
}

@media screen and (max-width: 767px) {
  .custom-user-info ::v-deep > .user-panel > .dropdown-menu {
    top: 5rem;
    margin-right: -0.9rem;
    min-width: 15rem;
  }
}
</style>
